import { render, staticRenderFns } from "./TemplateManagerIndex.vue?vue&type=template&id=cf6ef206&scoped=true&"
import script from "./TemplateManagerIndex.vue?vue&type=script&lang=js&"
export * from "./TemplateManagerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6ef206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf6ef206')) {
      api.createRecord('cf6ef206', component.options)
    } else {
      api.reload('cf6ef206', component.options)
    }
    module.hot.accept("./TemplateManagerIndex.vue?vue&type=template&id=cf6ef206&scoped=true&", function () {
      api.rerender('cf6ef206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplateManagerIndex.vue"
export default component.exports